import $ from 'jquery';
window.$ = window.jQuery = $;
import Cookies from 'js-cookie';
import Swiper from 'swiper/bundle';
import 'swiper/css';
import 'swiper/css/effect-fade';
// Add class to body on scroll

function notification() {
    $("body").on('click', '.notification .close', function () {
        $('header').addClass('shadow-3xl');
        $('.notification').slideUp(300);
        Cookies.set('notification', 'hidden', { expires: 7, path: '/' })
    });
}
notification()


function NavOnScroll() {
    $(window).on('scroll', function () {
        var scroll = $(window).scrollTop();
        if (scroll >= 100) {
            $("body").addClass("scrolled");
        } else {
            $("body").removeClass("scrolled");
        }
    });
}
NavOnScroll()

// Mobile menu toggle

function MobileMenu() {
    $("body").on('click', '.menu-toggle', function () {
        $('.menu-toggle').toggleClass('toggle-open');
        $('.mobile-menu').toggleClass('mobile-menu-open');
    });

    $("body").on('click', '.mobile-menu .menu-item-has-children', function () {
        $(this).find('ul.sub-menu').toggleClass('sub-menu-open');
        $(this).toggleClass('item-is-open');
    });
}
MobileMenu()




$("body").on('click', '.uzp__allfilters', function () {
    $('.uzp__categories').slideToggle(300);
});


function readMore() {
    $("body").on('click', '.readMore', function () {
        var toggle = $(this).parent().find('.readMore');
        $(this).parent().find('.more').slideToggle(300);
        if (toggle.html() === "Lees meer") {
            toggle.html('Lees minder');
            toggle.toggleClass('open');
        } else {
            toggle.html('Lees meer');
            toggle.toggleClass('open');
        }
    });
}
readMore()


function setCookie(name, value, lifetime_days) {
    var exp = new Date();
    exp.setDate(new Date().getDate() + lifetime_days);
    document.cookie = name + '=' + value + ';expires=' + exp.toUTCString() + ';path=/';
}

function getCookie(name) {
    if (document.cookie) {
        var regex = new RegExp(escape(name) + '=([^;]*)', 'gm'),
            matches = regex.exec(document.cookie);
        if (matches) {
            return matches[1];
        }
    }
}

if (getCookie('notify')) {
    $('.notification').remove();
}

$("body").on('click', '.close', function () {
    setCookie('notify', '1', 1);
    $('.notification').slideUp(200);
});


var recruiterSwiper = new Swiper(".recruiterSwiper", {
    effect: 'fade',
    speed: 2000,
    loop: true,
    lazy: true,
    autoplay: {
        delay: 3000,
    },
    fadeEffect: {
        crossFade: true
    },
});

var swiper = new Swiper(".referenceSwiper", {
    slidesPerView: 2,
    speed: 1000,
    spaceBetween: 32,
    loop: true,
    lazy: true,
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
    },
    autoHeight: true,
    autoplay: {
        delay: 6000,
        disableOnInteraction: true,
    },
    watchSlidesProgress: true,
    breakpoints: {
        "@0.00": {
            slidesPerView: 1,
            spaceBetween: 16,
        },
        "@0.60": {
            slidesPerView: 1,
        },
        "@1.00": {
            slidesPerView: 1,
        },
        "@1.50": {
            slidesPerView: 2,
        },
    },
});



var swiper = new Swiper(".teamSwiper", {
    slidesPerView: 1,
    speed: 1000,
    spaceBetween: 32,
    loop: true,
    lazy: true,
    navigation: {
        nextEl: '.prev',
        prevEl: '.next',
    },
});




$("body").on('click', '.worker', function () {
    $(this).toggleClass('active');
});
